import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseFpxControlComponent } from '@fpx/core';

@Component({
  selector: 'fpx-text-box',
  templateUrl: './text-box.component.html',
  styleUrls: ['./text-box.component.scss'],
  providers : [
    {
      provide : NG_VALUE_ACCESSOR,
      useExisting : forwardRef(() => FpxTextBoxComponent),
      multi : true
    }
  ],
  changeDetection : ChangeDetectionStrategy.OnPush
})
export class FpxTextBoxComponent extends BaseFpxControlComponent {
  @Input() maxLength: string | undefined;
  constructor(_controlContainer : ControlContainer,changeDetectorRef:ChangeDetectorRef) {
    super(_controlContainer,changeDetectorRef);
  }

  trimText() {
    this.formControl.setValue(this.formControl.value.trim(), {emitEvent: true,emitModelToViewChange: true});
  }

}
